export default __webpack_public_path__ + "static/media/1200px-ISO_C++_Logo.svg.0a81196c.png";